import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';

import {LogService} from '../log.service';
import {ReviewerFilmService} from '../reviewer-film.service';


@Injectable()
export class AllFilmsResolver implements Resolve<any> {
	constructor(
		private log: LogService,
		private reviewerFilmService: ReviewerFilmService
	) {}


	params: any = {};

	loadingFilmTimerId: any;


	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
		// console.log('AllFilmsResolver called    #1');
		// let startResolve = Date.now();

		this.loadingFilmTimerId = setTimeout(() => {
			this.log.showLoadingFilms = true;
		}, 1000);

		this.params = JSON.parse(JSON.stringify(route.params));

		let thePromise = new Promise((resolve, reject) => {
			// this.reviewerFilmService.getFilms()

			// this.reviewerFilmService.getRecentFilms()
			this.reviewerFilmService.getRecentFilmsIndexedDb()
				.then((films: any) => {

					// let endResolve = Date.now();
					// console.log('AllFilmsResolver called    #2, took ' + (endResolve - startResolve) + ' msec' );


					let allFilmsInfo = {
						allFilms: films.allFilms.films,
						params: this.params
					};
					clearTimeout(this.loadingFilmTimerId);
					this.log.showLoadingFilms = false;
					return resolve(allFilmsInfo);
				})
				.catch((err) => {
					clearTimeout(this.loadingFilmTimerId);
					this.log.showLoadingFilms = false;
					return reject(err);
				});
		});

		return Observable.fromPromise(thePromise);
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/all-films.resolver.ts